import React, { useState } from "react";
import GlobalStyleComponent from "./GlobalStyle";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Footer from "./comps/Footer";
import WhatsApp from "./comps/WhatsApp";
import HomePage from "./pages/HomePage";
import About from "./pages/AboutPage";
import Contact from "./pages/ContactPage";

export default () => {
  const [limit, setLimit] = useState(undefined);
  return (
    <>
      <BrowserRouter>
        <GlobalStyleComponent />
        <WhatsApp />
        <Routes>
          <Route
            path="/"
            element={<HomePage limit={limit} setLimit={setLimit} />}
          />
          <Route path="/sobre" element={<About />} />
          <Route path="/contato" element={<Contact />} />
        </Routes>

        <Footer />
      </BrowserRouter>
    </>
  );
};
